<template>
  <div
    style="
      width: 100%;
      display: flex;
      justify-content: flex-end;
      font-size: 7px;
      font-family: Arial, Helvetica, sans-serif;
      margin-right: 15px;
      margin-left: 20px;
    "
  >
    <div style="align-self: center; font-weight: bold;">
      Formulaire de vote par correspondance
      {{ $moment(toLocalTime(meetingDate)).locale("fr").format("DD MMMM YYYY") }}
      - <span>{{ buildingName }}</span>
    </div>
    <div style="border-left: 1px dotted #000; margin-left: 10px; padding-left: 10px;">
      <img :src="logoInBase64" alt="agency logo" height="35px" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["buildingName", "meetingDate", "logoInBase64"],
};
</script>
